<template>
 <span :class="{ 'has-error' : $v.value.$error }">
  <span class="form__label" :class="{ 'error_input' : $v.value.$error }">
          <label :for="name" class="form__label-title">{{label}}<span v-if="this.required">*</span></label>
          <input class="form__input"
            :id="name"
            :name="name"
            :type="type"
            :placeholder="placeholder"
            :required="required"
            :validators="validators"
            v-model.trim="$v.value.$model"
            @change="containsError($v.value)"
            @keyup="containsError($v.value)"/>
          <label v-if="this.required && $v.value.$dirty && !$v.value.required" class="form__label-title error">{{ $t('validations.required') }}</label>
          <label v-if="minLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'minLength').localizedErrorMessage) }}</label>
          <label v-if="maxLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'maxLength').localizedErrorMessage) }}</label>
          <label v-if="regexValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'regExp').localizedErrorMessage) }}</label>
          <label v-if="emailInputType && $v.value.$dirty && !$v.value.email" class="form__label-title error">{{ $t('validations.incorrectMail') }}</label>
      </span>
  </span>
</template>
<script>
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

export default {
  name: 'OnboardTextInput',
  mixins: [OnboardInputMixin],
};
</script>
